import * as _ from 'lodash'
import * as React from 'react'
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Card} from 'reactstrap';
import { ContentCardHeader } from '../../components/ui/ContentCardHeader';
import { FontAwesomeIcon } from '../../components/ui/FontAwesomeIcon';
import { GridContainer } from '../../components/ui/Grid';
import { SurveyManagementHttp } from './lib/http';
import { IFinalizeSample, ISurveySampleInstance, IVerificationBeforeSend, ISurveyCoachingVarRule } from './lib/interfaces';
import { truncateSync } from 'fs';

export interface ISurveyVariableFieldRulesContainerProps extends RouteComponentProps<void> {
  verification?: IVerificationBeforeSend;
}

export interface ISurveyVariableFieldRulesContainerState {
  varNames: string[],
  varRules: ISurveyCoachingVarRule[],
  newVariableValue: string
}

export class SurveyVariableFieldRulesContainer extends React.Component<ISurveyVariableFieldRulesContainerProps, {}> {
  state: ISurveyVariableFieldRulesContainerState = {
    varNames: [""],
    varRules: [],
    newVariableValue: ""
  }

  newVarInput: HTMLInputElement

  constructor(props) {
    super(props)
  }

  // Startthe page with getting the vars and selecting the first one in the result
  componentWillMount() {
    console.log("Mounting")
    SurveyManagementHttp.getFieldFormRuleVars()
      .then((res) => {
        this.setState({ varNames: res })
        this.updateRulesVar(res[0])
        console.log("Set Names and Rules: " + this.state.varNames + " __ " + this.state.varRules)
      })
  }

  currentVariable = "";

  // Get a new variable and its related rules
  updateRulesVar(v) {
    this.currentVariable = v;
    SurveyManagementHttp.getFieldFormRules(v).then((rs) => {
      const rules: ISurveyCoachingVarRule[] = rs.map((r) => {
        const ruleSet: ISurveyCoachingVarRule = {
          id: r.id, rule: r.rule, result: r.result
          , ruleInput: document.createElement("input") // { x = new HTMLInputElement(); x.value = r.rule; return x }
          , resultInput: document.createElement("input") // { x = new HTMLInputElement(); x.value = r.result; return x }
        }; return ruleSet;
      })
      this.setState({ varRules: rules })
    })
    console.log("Updated Rules")
  }

  // Create a new variable
  addVariable() {
    SurveyManagementHttp.addFieldFormRuleVar(this.newVarInput.value)
      .then((rs) => {
        this.setState({ varNames: rs, newVariableValue: "" })
      })
    console.log("Setting new variable to " + this.newVarInput.value)
  }


  // Create new rule row
  addRow() {
    SurveyManagementHttp.addFieldRule(this.currentVariable, "TRUE", "1", "10")
      .then((rs) => {
        this.setState({ varRules: rs })
        // this.syncRulesAndResults(rs)
      })
  }

  // In memory sync between page and model
  syncInputToRule() {

    const vrs: ISurveyCoachingVarRule[] = this.state.varRules.map((r) => {
      const ruleSet: ISurveyCoachingVarRule =
        { id: r.id, rule: r.ruleInput.value, result: r.result, ruleInput: r.ruleInput, resultInput: r.resultInput };
      return ruleSet;
    })
    this.setState({ varRules: vrs })
  }

  // In memory sync between page and model
  syncInputToResult() {

    const vrs: ISurveyCoachingVarRule[] = this.state.varRules.map((r) => {
      const ruleSet: ISurveyCoachingVarRule =
        { id: r.id, rule: r.rule, result: r.resultInput.value, ruleInput: r.ruleInput, resultInput: r.resultInput };
      return ruleSet;
    })
    this.setState({ varRules: vrs })
  }

  // save the model to the database
  save() {
    SurveyManagementHttp.remFieldFormRuleVar(this.currentVariable)
    this.state.varRules.forEach((r) => {
      if (!(!r.rule || 0 === r.rule.length)) { // rule is not empty
        SurveyManagementHttp.addFieldRule(this.currentVariable, r.rule, r.result, r.id)
      }
    })
    console.log("Rules Saved")
  }

  render() {
    return (
      <section className="blacklight page-bg page-container">
        <GridContainer className="subtleSlideInRight">
          <Card >
            <ContentCardHeader header={
              <header>
                <span>Select the Field Replacement Variable Below</span>
              </header>
            } />
            <div className="input-field">
              <div className="label">Field Replacement Variables</div>
              <select style={{ width: 'auto' }} className="browser-default"
                onChange={(v) => { this.updateRulesVar(v.currentTarget.value) }}>
                {this.state.varNames.map((el) =>
                  <React.Fragment key={el}>
                    <option key={el} value={el}>{el}</option>
                  </React.Fragment>
                )}
              </select>
              <div ><input style={{ width: 'auto' }} type="text" ref={c => (this.newVarInput = c)} value={this.state.newVariableValue} onChange={(e) => this.setState({ newVariableValue: e.currentTarget.value })} /><Button onClick={(ev) => this.addVariable()}>Add</Button></div>
            </div>
          </Card>
          <Card>
            <ContentCardHeader header={
              <header>
                <span>Rules for variable: </span>
              </header>
            } />
            <div id="ruleTable" >
              <table className="table table-striped table-sm">
                <thead>
                  <tr>
                    <td>Rule</td>
                    <td>Result</td>
                  </tr>
                </thead>
                <tbody>
                  {this.state.varRules.map((rule) =>
                    <React.Fragment key={rule.id}>
                      <tr>
                        {
                          <>
                            <td className="p-2"><input ref={c => rule.ruleInput = c} type="text" value={rule.rule} onChange={(v) => this.syncInputToRule()} />
                            </td>
                            <td className="p-2"><input ref={c => rule.resultInput = c} type="text" value={rule.result} onChange={(v) => this.syncInputToResult()} /></td>
                          </>
                        }
                      </tr>
                    </React.Fragment>
                  )}
                </tbody>
              </table>
            </div>
            <div><Button onClick={(ev) => this.addRow()}>Add Rule</Button>
              <Button type="button"
                color="primary"
                onClick={(ev) => this.save()}><FontAwesomeIcon regular icon="save" fixedWidth verticalAlign="middle" />Save</Button></div>
          </Card>
        </GridContainer>
      </section>
    )

  }

}
